import { render, staticRenderFns } from "./Contabilidad.vue?vue&type=template&id=75d051ce&"
import script from "./Contabilidad.vue?vue&type=script&lang=js&"
export * from "./Contabilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Contabilidad.vue"
export default component.exports